import * as React from "react";
import { IfPermitted, PageHeader, DocumentTitle } from "components/common";
import UsersPageNavigation from "components/users/navigation/UsersPageNavigation";
import DocsHelper from "util/DocsHelper";
import CreateButton from "components/common/CreateButton";
import LicenseCheck from "../../license/LicenseCheck";
import TeamsOverview from "../components/teams-overview/TeamsOverview";
const TeamsOverviewPage = () => /* @__PURE__ */ React.createElement(DocumentTitle, { title: "Teams Overview" }, /* @__PURE__ */ React.createElement(UsersPageNavigation, null), /* @__PURE__ */ React.createElement(
  PageHeader,
  {
    title: "Teams Overview",
    actions: /* @__PURE__ */ React.createElement(IfPermitted, { permissions: "team:create" }, /* @__PURE__ */ React.createElement(LicenseCheck, { featureName: "teams", displayLicenseWarning: false }, ({ licenseIsValid }) => /* @__PURE__ */ React.createElement(CreateButton, { entityKey: "Team", disabled: !licenseIsValid }))),
    documentationLink: {
      title: "Permissions documentation",
      path: DocsHelper.PAGES.USERS_ROLES
    }
  },
  /* @__PURE__ */ React.createElement("span", null, "Overview of all teams. Teams allow granting permissions and capabilities to multiple users. The team details page provides an overview of all entities which are being shared with a team. Teams can be managed manually or synced from external resources like LDAP.")
), /* @__PURE__ */ React.createElement(TeamsOverview, null));
export default TeamsOverviewPage;
